"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = [{
  'id': 1,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '首页',
  'link': 'https://www.gaoding.com',
  'is_new': 0,
  'is_gray': 0,
  'priority': 110,
  'created_at': 1543302246,
  'updated_at': 1543302246,
  'children': []
}, {
  'id': 2,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '稿定抠图',
  'link': 'https://www.gaoding.com/koutu',
  'is_new': 0,
  'is_gray': 0,
  'priority': 100,
  'created_at': 1543302276,
  'updated_at': 1545116155,
  'children': []
}, {
  'id': 3,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '新媒体配图',
  'link': 'https://www.gaoding.com/templets/platform/64/category/128',
  'is_new': 0,
  'is_gray': 0,
  'priority': 90,
  'created_at': 1543302302,
  'updated_at': 1543302302,
  'config': {
    'title': '新媒体'
  },
  'children': [{
    'id': 7,
    'deleted': 0,
    'status': 1,
    'parent_id': 3,
    'title': '新版公众号首图',
    'link': 'https://www.gaoding.com/templets/platform/64/category/128',
    'is_new': 1,
    'is_gray': 0,
    'priority': 110,
    'created_at': 1543302416,
    'updated_at': 1543305026
  }, {
    'id': 8,
    'deleted': 0,
    'status': 1,
    'parent_id': 3,
    'title': '公众号首图',
    'link': 'https://www.gaoding.com/templets/platform/64/category/1',
    'is_new': 0,
    'is_gray': 0,
    'priority': 100,
    'created_at': 1543302441,
    'updated_at': 1543302441
  }, {
    'id': 9,
    'deleted': 0,
    'status': 1,
    'parent_id': 3,
    'title': '公众号次图',
    'link': 'https://www.gaoding.com/templets/platform/64/category/2',
    'is_new': 0,
    'is_gray': 0,
    'priority': 90,
    'created_at': 1543302461,
    'updated_at': 1543302461
  }, {
    'id': 10,
    'deleted': 0,
    'status': 1,
    'parent_id': 3,
    'title': '关注二维码',
    'link': 'https://www.gaoding.com/templets/platform/64/category/8',
    'is_new': 0,
    'is_gray': 0,
    'priority': 80,
    'created_at': 1543302496,
    'updated_at': 1543302502
  }, {
    'id': 11,
    'deleted': 0,
    'status': 1,
    'parent_id': 3,
    'title': '朋友圈封面',
    'link': 'https://www.gaoding.com/templets/platform/64/category/32',
    'is_new': 0,
    'is_gray': 0,
    'priority': 70,
    'created_at': 1543302527,
    'updated_at': 1543302527
  }]
}, {
  'id': 4,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '电商素材',
  'link': 'https://dianshang.gaoding.com',
  'is_new': 0,
  'is_gray': 0,
  'priority': 80,
  'created_at': 1543302343,
  'updated_at': 1545116148,
  'children': [{
    'id': 24,
    'deleted': 0,
    'status': 1,
    'parent_id': 4,
    'title': '店铺首页',
    'link': 'https://dianshang.gaoding.com/shop',
    'is_new': 1,
    'is_gray': 0,
    'priority': 120,
    'created_at': 1543306686,
    'updated_at': 1544718136
  }, {
    'id': 27,
    'deleted': 0,
    'status': 1,
    'parent_id': 4,
    'title': '海报',
    'link': 'https://dianshang.gaoding.com/poster',
    'is_new': 0,
    'is_gray': 0,
    'priority': 115,
    'created_at': 1544694010,
    'updated_at': 1544717391
  }, {
    'id': 26,
    'deleted': 0,
    'status': 1,
    'parent_id': 4,
    'title': '主图/直通车',
    'link': 'https://dianshang.gaoding.com/icons/platform/32/category/32',
    'is_new': 0,
    'is_gray': 0,
    'priority': 82,
    'created_at': 1544675477,
    'updated_at': 1544717523
  }, {
    'id': 23,
    'deleted': 0,
    'status': 1,
    'parent_id': 4,
    'title': '详情页',
    'link': 'https://dianshang.gaoding.com/cjxq/templates',
    'is_new': 0,
    'is_gray': 0,
    'priority': 60,
    'created_at': 1543305522,
    'updated_at': 1544717490
  }, {
    'id': 22,
    'deleted': 0,
    'status': 1,
    'parent_id': 4,
    'title': '装修工具',
    'link': 'https://dianshang.gaoding.com/tools',
    'is_new': 0,
    'is_gray': 0,
    'priority': 50,
    'created_at': 1543305507,
    'updated_at': 1543305507
  }]
}, {
  'id': 5,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '手机海报',
  'link': 'https://www.gaoding.com/templets/platform/64/category/4',
  'is_new': 0,
  'is_gray': 0,
  'priority': 70,
  'created_at': 1543302364,
  'updated_at': 1543302364,
  'children': []
}, {
  'id': 6,
  'deleted': 0,
  'status': 1,
  'parent_id': 0,
  'title': '企业行政',
  'link': 'https://qiye.gaoding.com',
  'is_new': 0,
  'is_gray': 0,
  'priority': 60,
  'created_at': 1543302382,
  'updated_at': 1545116142,
  'children': [{
    'id': 29,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': '年会',
    'link': 'https://qiye.gaoding.com/suits',
    'is_new': 0,
    'is_gray': 0,
    'priority': 120,
    'created_at': 1545016755,
    'updated_at': 1545016755
  }, {
    'id': 12,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': '招聘',
    'link': 'https://qiye.gaoding.com/templets/platform/256/category/1/?scene=1',
    'is_new': 0,
    'is_gray': 0,
    'priority': 110,
    'created_at': 1543302567,
    'updated_at': 1543302567
  }, {
    'id': 13,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': '员工关怀',
    'link': 'https://qiye.gaoding.com/templets/platform/256/category/2?scene=2',
    'is_new': 0,
    'is_gray': 0,
    'priority': 100,
    'created_at': 1543302584,
    'updated_at': 1543306506
  }, {
    'id': 14,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': 'PPT',
    'link': 'https://qiye.gaoding.com/templets/platform/256/category/4?scene=4',
    'is_new': 0,
    'is_gray': 0,
    'priority': 90,
    'created_at': 1543302598,
    'updated_at': 1543302598
  }, {
    'id': 15,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': '企业印刷',
    'link': 'https://qiye.gaoding.com/templets/platform/256/category/16?scene=16&filter=236',
    'is_new': 0,
    'is_gray': 0,
    'priority': 80,
    'created_at': 1543302621,
    'updated_at': 1543302621
  }, {
    'id': 16,
    'deleted': 0,
    'status': 1,
    'parent_id': 6,
    'title': '简历',
    'link': 'https://qiye.gaoding.com/templets/platform/256/category/32?scene=32',
    'is_new': 0,
    'is_gray': 0,
    'priority': 70,
    'created_at': 1543302636,
    'updated_at': 1543302642
  }]
}];
exports.default = _default;